import React, { type Key, type ReactElement } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import { repeat } from 'src/common/helpers/RepeatHelper';

type FixedSizeArray<N extends number, T = unknown> = T[] & { length: N };

type SkeletonRowProps<N extends number = number> = {
	count: N;
	columnCount: N;
	height: string;
	// width: string;
	animationSpeed: number;
	keySet: FixedSizeArray<N, Key>;
	columnKeySet: FixedSizeArray<N, Key>;
};

export const TableRows = <N extends number>({
	count,
	columnCount,
	height,
	keySet,
	animationSpeed,
	columnKeySet
}: SkeletonRowProps<N>): ReactElement => (
	<>
		{repeat(count).map((_, i) => (
			<tr key={keySet[i]} className="table-skeleton__row" style={{ height }}>
				{Array.from({ length: columnCount }).map((_, colIndex) => (
					<td
						key={`cell-${keySet[i]}-${columnKeySet[colIndex]}`}
						className="table-skeleton__data-cell"
						aria-label={`Row ${colIndex + 1}, Column ${colIndex + 1}`}
					>
						<EvSkeleton width="100%" height="24px" animationSpeed={animationSpeed} />
					</td>
				))}
			</tr>
		))}
	</>
);
